export type AvailabilityExceptionKind = "BLOCKED" | "AVAILABLE";

export interface TemplateWindow {
  id: string;
  day_of_week: number; // 0 = Monday, 6 = Sunday
  start_time: string; // "HH:MM" or "HH:MM:SS"
  end_time: string;
}

export interface AvailabilityException {
  id: string;
  date: string; // YYYY-MM-DD
  kind: AvailabilityExceptionKind;
  start_time: string | null;
  end_time: string | null;
}

export interface CalendarResponse {
  template: TemplateWindow[];
  exceptions: AvailabilityException[];
  initialized: boolean;
}

export interface TemplateWindowInput {
  day_of_week: number;
  start_time: string;
  end_time: string;
}

export interface SetTemplatePayload {
  windows: TemplateWindowInput[];
}

export interface ExceptionWindowInput {
  start_time: string;
  end_time: string;
}

export interface SetExceptionPayload {
  kind: AvailabilityExceptionKind;
  windows: ExceptionWindowInput[];
}

export const DAY_LABELS: readonly [string, string, string, string, string, string, string] = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

export const DAY_LABELS_LONG: readonly string[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
